import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as groupCategoryAction from "../../../../../actions/groupCategoryAction";
import * as groupActions from "../../../../../actions/groupAction";
import DEFINE, { UPLOAD_DIRECTORY, VALIDATE_ENUM, DETAIL_ACTIONS, FEATURE_FLAGS, PATHS, DATE_TIME_FORMAT, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Tooltip, Icon, Input as AntInput } from 'antd';
import moment from 'moment';
import $ from 'jquery';
import Input from '../../../common/component/Input';
import Checkbox from '../../../common/component/Checkbox';
import Select, { Option } from '../../../common/component/Select';
import RichTextEditor, { ClassicEditor } from '../../../common/component/RichTextEditor';
import TextArea from '../../../common/component/TextArea';
import TreeSelect from '../../../common/component/TreeSelect';
import UploadImage from '../../../common/component/UploadImage';
import { omit, cloneDeep, merge, every, toArray, get } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Group, { GroupPrices } from '../../../../../models/Group';
import Span from '../../../common/component/Span';
import Wrapper from '../../../common/component/Wrapper';

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: merge(new Group(), {
        propertyIds: [],
        productIds: [],
        acceptCheck: false,
        isAvailable: true,
        limitNumberOfTimes: 1,
        isSaleToWeb: true,
        groupPrices: new GroupPrices(),
    }),
    fileMultiple: [],
    allProperties: [],
    allProducts: [],
    allCategories: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
    createVoucher: false,
    acceptCheck: false,
    isUploadMultiple: false,
    thumbImage: {},
};
let permissionActions = [];
class ActionComponent extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.GROUP);
        this.setState({ fileMultiple: [] });
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetUpdate({ id: match.params.id, props: this.props });
        }
        this.props.onListAllProperties();
        this.props.onListAllProducts();
        this.props.getAllGroupCategories();
    }

    validation = (field, reload) => {
        const { t, dataUpdate } = this.props;
        let voucherRun, voucherInvalid;
        if (dataUpdate) {
            voucherRun = ((new Date(dataUpdate.saleStartDate)).getTime() < (new Date()).getTime());
            voucherInvalid = ((new Date(dataUpdate.endDate)).getTime() < (new Date()).getTime());
        }
        if (voucherRun || voucherInvalid) {
            this.setState({ validation: {} });
            return false;
        }
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                minLength: {
                    propertyIds: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.propertyIds`)),
                    productIds: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.productIds`)),
                    
                },
                // maxValueNumber: {
                //     salePrice: t('validation.salePriceLessThenPrice'),
                // },
                maxLength: {
                    shortDescription: Func.formatValidation(t('validation.statusCode.code.4'), VALIDATE_ENUM.MAX_LENGTH.SHORT_DESCRIPTION),
                },
                minValueNumber: {
                    limitNumberOfTimes: t('validation.LessThenZero'),
                    numberOfBookingPeriod: t('validation.LessThenZero'),
                },
                minImage: { images: t('validation.image1pic') },
                required: {
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.name`)),
                    limitNumberOfTimes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.limitNumberOfTimes`)),
                    startDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.startDate`)),
                    saleStartDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.saleStartDate`)),
                    endDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.endDate`)),
                    saleEndDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.saleEndDate`)),
                    discountValue: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.discountValue`)),
                    description: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.description`)),
                    propertyIds: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.properties`)),
                    productIds: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.productIds`)),
                    voucherType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.voucherType`)),
                    thumbImage: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.thumbImage`)),
                    numberOfBookingPeriod: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.numberOfBookingPeriod`)),
                    bookingPeriod: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.bookingPeriod`)),
                    shortDescription: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.shortDescription`)),
                },
                isNumber: { order: Func.formatValidation(t('validation.statusCode.code.2'), t(`item.group.order`)) }
            };
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            if(this.state.action === DETAIL_ACTIONS.UPDATE) {
                validate.required.urlSlug = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.urlSlug`));
            }
            if(this.state.data.installmentFee || this.state.data.installmentLimit) {
                validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
                validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
            }
            let valueValidate = {
                minLength: {
                    propertyIds: 1,
                    productIds: 1,
                },
                maxLength: {
                    shortDescription: VALIDATE_ENUM.MAX_LENGTH.SHORT_DESCRIPTION,
                },
                maxValueNumber: { salePrice: parseInt(this.state.data.originalPrice) },
                minValueNumber: { limitNumberOfTimes: 1, originalPrice: 1, numberOfBookingPeriod: 1 },
                minImage: { images: 1 },
                
            };
            if (this.state.data.voucherType === DEFINE.GENERAL.VOUCHER_TYPE.PERCENT) {
                validate = {
                    ...validate,
                    minValueNumber: {
                        ...validate.minValueNumber,
                        discountValue: t('validation.LessThenZero'),
                        maxDiscountValue: t('validation.LessThenZero'),
                        minOrderValue: t('validation.LessThenZero'),
                        maxOrderValue: t('validation.LessThenZero'),
                    },
                    maxValueNumber: {
                        ...validate.maxValueNumber,
                        discountValue: t('validation.percent'),
                        minOrderValue: t('validation.minOrderValue')
                    }
                };
                valueValidate = {
                    ...valueValidate,
                    minValueNumber: {
                        ...valueValidate.minValueNumber,
                        discountValue: 1,
                        maxDiscountValue: 1,
                        minOrderValue: 1,
                        maxOrderValue: 1,
                    },
                    maxValueNumber: {
                        ...valueValidate.maxValueNumber,
                        discountValue: 100,
                    }
                };
                if (parseInt(this.state.data.maxOrderValue) > 0) {
                    valueValidate = {
                        ...valueValidate,
                        maxValueNumber: {
                            ...valueValidate.maxValueNumber,
                            minOrderValue: parseInt(this.state.data.maxOrderValue)
                        }
                    };
                }
            } else if (this.state.data.voucherType === DEFINE.GENERAL.VOUCHER_TYPE.MONEY) {
                validate = {
                    ...validate,
                    minValueNumber: {
                        ...validate.minValueNumber,
                        discountValue: t('validation.LessThenZero'),
                        minOrderValue: t('validation.LessThenZero'),
                        maxOrderValue: t('validation.LessThenZero'),
                    },
                    maxValueNumber: { ...validate.maxValueNumber, minOrderValue: t('validation.minOrderValue') }
                };
                valueValidate = {
                    ...valueValidate,
                    minValueNumber: {
                        ...valueValidate.minValueNumber,
                        discountValue: 1,
                        minOrderValue: 1,
                        maxOrderValue: 1,
                    },
                    maxValueNumber: {
                        ...valueValidate.maxValueNumber,
                    }
                };
                if (parseInt(this.state.data.maxOrderValue) > 0) {
                    valueValidate = {
                        ...valueValidate,
                        maxValueNumber: {
                            ...valueValidate.maxValueNumber,
                            minOrderValue: parseInt(this.state.data.maxOrderValue)
                        }
                    };
                }
            }
            result = Func.multipleValidate(data, validate, valueValidate);
            if (every(toArray(data.groupPrices), item => !item.originalPrice)) {
                result.groupPrices = Func.messageValidator(true, 'groupPrices', t(`item.group.groupPricesMinimum`)).groupPrices
            } else {
                toArray(data.groupPrices).forEach(price => {
                    if (price.originalPrice) {
                        if (Number(price.originalPrice) < 0) {
                            result.groupPrices = result.groupPrices || {};
                            result.groupPrices[price.currencyCode] = result.groupPrices[price.currencyCode] || {};
                            result.groupPrices[price.currencyCode].originalPrice = Func.messageValidator(true, 'originalPrice', t('validation.LessThenZero')).originalPrice;
                        }
                        if (Number(price.originalPrice) < Number(price.salePrice)) {
                            result.groupPrices = result.groupPrices || {};
                            result.groupPrices[price.currencyCode] = result.groupPrices[price.currencyCode] || {};
                            result.groupPrices[price.currencyCode].salePrice = Func.messageValidator(true, 'salePrice', t('validation.salePriceLessThenPrice')).salePrice;
                        }
                    }
                });
            }
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.groups.isSubmit,
            isGetItem: nextProps.groups.isGetItem,
            isUpload: nextProps.file.isFetching,
            isUploadMultiple: nextProps.file.isFetchingMultiple,
            isFetchingUpdate: nextProps.groups.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties !== prevProps.properties) {
            let newData = Func.customOptionSelectHMS(this.props.properties.allProperties, ['name', 'id']);
            this.setState({
                allProperties: newData,
            });
        }
        if (this.props.products !== prevProps.products) {
            let newData = Func.customOptionSelectHMS(this.props.products.allProducts, ['name', 'id']);
            this.setState({
                allProducts: newData,
            });
        }
        if (this.props.groupCategories !== prevProps.groupCategories) {
            this.setState({
                allCategories: this.props.groupCategories.allGroupCategories,
            });
        }
        if (this.props.file !== prevProps.file) {
            if (this.props.file.file) {
                let fileMulti = this.state.fileMultiple;
                let fileNameMulti = this.state.data.images ? this.state.data.images : [];
                let oldThumbImage = this.state.thumbImage;
                let thumbImageName = this.state.data.thumbImage ? this.state.data.thumbImage : "";
                if (this.props.file.file.type === 1) {
                    fileMulti.push(this.props.file.file.data);
                    fileNameMulti.push(this.props.file.file.data.fileName)
                } else if (this.props.file.file.type === 0) {
                    oldThumbImage = this.props.file.file.data;
                    thumbImageName = this.props.file.file.data.fileName;
                }
                this.setState({
                    file: this.props.file.file.type === 0 ? this.props.file.file : undefined,
                    data: merge(this.state.data, {
                        thumbImage: thumbImageName,
                        images: fileNameMulti
                    }),
                    fileMultiple: fileMulti,
                    thumbImage: oldThumbImage || undefined,
                });
            }
        }
        if (this.props.groups.dataUpdate !== prevProps.groups.dataUpdate) {
            let data = this.props.groups.dataUpdate;
            let listImages = this.props.groups.dataUpdate.imagesView;
            let thumbImageName = this.props.groups.dataUpdate.thumbImage;
            let thumbImageView = this.props.groups.dataUpdate.thumbImageView;
            let arrayImages = [];
            let fileName = [];
            let arrayProperties = [];
            let arrayProducts = [];
            let arrayCategories = [];
            listImages.map(i => {
                arrayImages.push({ fileUrl: i.fileUri ? i.fileUri : i.fileUrl, fileName: i.filename });
                fileName.push(i.filename);
            });
            if (this.props.groups.dataUpdate.properties && this.props.groups.dataUpdate.properties.length > 0) {
                this.props.groups.dataUpdate.properties.map((i) => {
                    arrayProperties.push(i.id);
                });
            }
            if (this.props.groups.dataUpdate.products && this.props.groups.dataUpdate.products.length > 0) {
                this.props.groups.dataUpdate.products.map((i) => {
                    arrayProducts.push(i.id);
                });
            }
            if (this.props.groups.dataUpdate.categories && this.props.groups.dataUpdate.categories.length > 0) {
                this.props.groups.dataUpdate.categories.map((i) => {
                    arrayCategories.push(i.id);
                });
            }
            this.setState({
                data: merge(data, {
                    images: fileName,
                    thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
                    thumbImageView: thumbImageView,
                    propertyIds: arrayProperties,
                    productIds: arrayProducts,
                    categoryIds: arrayCategories,
                }),
                checkData: {
                    endDate: this.props.groups.dataUpdate.endDate,
                    saleStartDate: this.props.groups.dataUpdate.saleStartDate,
                },
                fileMultiple: arrayImages,
                thumbImage: thumbImageView || undefined,
            })
        }
    }

    onChange = (e, tag) => {
        const data = this.state.data;

        if (tag) {
            data[tag] = e;
            this.setState({ data });
            this.validation(tag, true)
        } else {
            let params = Func.getValueForm(e);
            let arrayNumber = ['originalPrice', 'salePrice', 'discountValue', 'limitNumberOfTimes', 'maxDiscountValue', 'minOrderValue', 'maxOrderValue'];
            if (arrayNumber.includes(params.name)) {
                params.value = Func.formatNumber(params.value)
            }

            if (params.name === "voucherType" && params.value === DEFINE.GENERAL.VOUCHER_TYPE.GIFT) {
                data.discountValue = 1;
                data[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
                this.setState({ data });
                Func.lastRequest(300).then(() => {
                    this.validation('discountValue', true);
                });
                return false;
            }
            data[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
            this.setState({ data });
            this.validation(params.name, true)
        }
    };

    onChangeUrlSlug = (e) => {
        const value = Func.formatUrlSlug(e.target.value);
        return this.onChange(value, 'urlSlug');
    }

    onSubmit = (e) => {
        e.preventDefault();
        let { action, data } = this.state
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (data.acceptCheck) {
                if (action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE) {
                    if (data.startDate.isAfter(data.endDate)) {
                        message.error(this.props.t('validation.statusCode.code.10007'));
                        return false;
                    }
                    if (data.stayStartDate && data.stayEndDate && data.stayStartDate.isAfter(data.stayEndDate)) {
                        message.error(this.props.t('validation.statusCode.code.10010'));
                        return false;
                    }
                    
                    // if (moment(data.startDate, "DD-MM-YYYY").isAfter(moment(moment(), "DD-MM-YYYY"))) {
                    //     message.error(this.props.t('validation.statusCode.code.10101'));
                    //     return false;
                    // }
                    if (moment(data.saleEndDate).startOf('day').isAfter(data.endDate)) {
                        message.error(this.props.t('validation.statusCode.code.10008'));
                        return false;
                    }
                    if (data.saleStartDate.isAfter(data.saleEndDate)) {
                        message.error(this.props.t('validation.statusCode.code.10007'));
                        return false;
                    }
                    let newData = this.state.data;
                    Object.keys(newData.groupPrices).forEach(key => {
                        if (!newData.groupPrices[key].originalPrice) {
                            newData.groupPrices[key].originalPrice = undefined;
                        }
                    });
                    if (newData.productIds && newData.productIds.length) {
                        newData.products = newData.productIds.map(id => ({ id }));
                    }
                    if (newData.propertyIds && newData.propertyIds.length) {
                        newData.properties = newData.propertyIds.map(id => ({ id }));
                    }
                    if (newData.categoryIds && newData.categoryIds.length) {
                        newData.categories = newData.categoryIds.map(id => ({ id }));
                    }
                    this.saveGroup({ data: newData, props: this.props }, this.props.onCreateGroup);
                } else if (this.state.action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE) {
                    let dataUpdate = this.state.data;
                    let newData = this.state.data;
                    if (dataUpdate.startDate || dataUpdate.endDate) {
                        if (data.startDate.isAfter(data.endDate)) {
                            message.error(this.props.t('validation.statusCode.code.10007'));
                            return false;
                        }
                    }
                    if (dataUpdate.stayStartDate && dataUpdate.stayEndDate) {
                        if (dataUpdate.stayStartDate.isAfter(dataUpdate.stayEndDate)) {
                            message.error(this.props.t('validation.statusCode.code.10010'));
                            return false;
                        }
                    }
                    if (moment(data.saleEndDate).startOf('day').isAfter(data.endDate)) {
                        message.error(this.props.t('validation.statusCode.code.10008'));
                        return false;
                    }
                    if (dataUpdate.saleStartDate || dataUpdate.saleEndDate) {
                        if (data.saleStartDate.isAfter(data.saleEndDate)) {
                            message.error(this.props.t('validation.statusCode.code.10007'));
                            return false;
                        }
                    }
                    Object.keys(newData.groupPrices).forEach(key => {
                        if (!newData.groupPrices[key].originalPrice) {
                            newData.groupPrices[key].originalPrice = undefined;
                        }
                    });
                    if (typeof newData.thumbImage !== 'string') {
                        newData.thumbImage = undefined;
                    }
                    if (newData.productIds && newData.productIds.length) {
                        newData.products = newData.productIds.map(id => ({ id }));
                    }
                    if (newData.propertyIds && newData.propertyIds.length) {
                        newData.properties = newData.propertyIds.map(id => ({ id }));
                    }
                    if (newData.categoryIds && newData.categoryIds.length) {
                        newData.categories = newData.categoryIds.map(id => ({ id }));
                    }
                    this.saveGroup({ data: merge(newData, { id: this.state.data.id }), props: this.props }, this.props.onUpdateGroup);
                }
            } else {
                message.error(i18n.t('item.group.acceptInfo'))
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    onCreateVoucher = () => {
        this.setState({
            createVoucher: !this.state.createVoucher
        })
    };

    uploadFileMultiple = (file) => {
        let data = file.target.files;
        let lengthImage = this.state.fileMultiple;
        if (data.length > 5) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 5));
            return false;
        }
        if ((lengthImage.length + data.length) > 5) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 5));
            return false;
        }
        this.setState({
            isUploadMultiple: true,
        });
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(data).map((i) => {
            if (imageValidation.includes(data[i].type)) {
                this.props.onUploadFile({ file: data[i], directory: UPLOAD_DIRECTORY.IMAGES, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    };

    saveGroup = (params, updateFunc) => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onSaveTranslate(params.data)
        } else {
            updateFunc(params)
        }
    }

    onShowTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
        this.setImageView(data);
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
        this.setImageView(data);
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.GROUP.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
        const translateFunction = data.translate.id ? this.props.updateGroupTranslate : this.props.createGroupTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        // this.props.deleteGroupCategoryTranslate(data, { id: data.id });
        this.props.deleteGroupTranslate(data, { id: data.id });
    }

    setImageView = (dataUpdate) => {
        let arrayImages = [];
        let fileName = [];
        let thumbImageName = dataUpdate.thumbImage;
        let thumbImageView = dataUpdate.thumbImageView;
        let listImages = dataUpdate.imagesView;
        listImages.map(i => {
            arrayImages.push({ fileUrl: i.fileUri ? i.fileUri : i.fileUrl, fileName: i.filename });
            fileName.push(i.filename);
        });

        this.setState({
            data: merge(dataUpdate, {
                images: fileName,
                thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
                thumbImageView: thumbImageView,
            }),
            fileMultiple: arrayImages,
            thumbImage: thumbImageView || undefined,
        })
    }

    uploadFile = (file) => {
        let data = this.state.data;
        data.thumbImage = undefined;
        this.setState({
            isUpload: true,
            data: data
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.GROUP_THUMB, isFile: 1 });
    };

    render() {
        const { t, groupCategories } = this.props;
        const { data, validation, isSubmit, isGetItem, action, isUpload, file, checkData, allProperties, allProducts, allCategories, createVoucher, isUploadMultiple } = this.state;
        let voucherRun = checkData ? ((new Date(checkData.saleStartDate)).getTime() < (new Date()).getTime()) : false;
        let voucherInvalid = checkData ? ((new Date(checkData.endDate)).getTime() < (new Date()).getTime()) : false;
        if (action !== "UPDATE") {
            voucherRun = false;
            voucherInvalid = false
        }

        const isInstallment = data.installmentFee || data.installmentLimit
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'groups'}
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.group.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.group.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange(language.code, 'languageCode')}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('groups', this.props)}
                            activeComponent={permissionActions && permissionActions.allowUpdate}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.group.acceptcheck`)}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            submitButtonRight={true}
                            statusActiveName={`acceptCheck`}
                            statusActive={data.acceptCheck}
                            showActiveComponent={true}
                            disableButtonSubmit={permissionActions && !permissionActions.allowUpdate}
                            propsButtonSubmit={{ disabled: !data.acceptCheck || voucherInvalid || (permissionActions && !permissionActions.allowUpdate) }}
                        >
                            <HMS.FormWrapperItem>
                                <div className={`col-md-6`}>
                                    <HMS.HeaderComponent title={t('item.group.showInfo.info')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.group.name`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            // placeholder={Func.formatValidation(t('validation.statusCode.code.10'), t(`item.group.name`))}
                                            className="form-control" name="name" onChange={this.onChange}
                                            value={data.name ? data.name : ""} />
                                    </HMS.FormWrapperInputComponent>
                                    {action === DETAIL_ACTIONS.UPDATE &&
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={data.urlSlug}
                                            validation={validation.urlSlug}
                                            labelTitle={t(`item.group.urlSlug`)}
                                        >
                                            <Input type="text"
                                                autoComplete="off"
                                                className="form-control" name="urlSlug" onChange={this.onChangeUrlSlug}
                                                value={Func.checkUndefine(data.urlSlug)} />
                                        </HMS.FormWrapperInputComponent>
                                    }
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.propertyIds}
                                        validation={validation.propertyIds}
                                        labelTitle={t(`item.group.properties`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <HMS.LoadingComponent spinning={allProperties.length < 0}>
                                            <HMS.SelectComponent name={`propertyIds`}
                                                optionFilterProp="children"
                                                mode="multiple"
                                                className={`hms-form-control`}
                                                value={data.propertyIds}
                                                showSearch
                                                hmsData={allProperties}
                                                onChange={(e) => this.onChange(e)} />
                                        </HMS.LoadingComponent>
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.productIds}
                                        validation={validation.productIds}
                                        labelTitle={t(`item.group.product`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <HMS.LoadingComponent spinning={allProducts.length < 0}>
                                            <HMS.SelectComponent name={`productIds`}
                                                optionFilterProp="children"
                                                mode="multiple"
                                                className={`hms-form-control`}
                                                value={data.productIds}
                                                showSearch
                                                hmsData={allProducts}
                                                onChange={(e) => this.onChange(e)} />
                                        </HMS.LoadingComponent>
                                    </HMS.FormWrapperInputComponent>
                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.group.categories`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <HMS.LoadingComponent spinning={groupCategories.isFetching}>
                                            <TreeSelect
                                                style={{ width: '100%' }}
                                                value={data.categoryIds}
                                                treeDefaultExpandAll multiple allowClear
                                                treeData={allCategories}
                                                onChange={e => this.onChange(e, 'categoryIds')}
                                            />
                                        </HMS.LoadingComponent>
                                    </HMS.FormWrapperInputComponent>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            {/* <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.originalPrice}
                                                validation={validation.originalPrice}
                                                labelTitle={t(`item.group.originalPrice`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input
                                                    disabled={voucherRun || voucherInvalid}
                                                    value={data.originalPrice ? Func.formatMoney(data.originalPrice.toString()) : ""}
                                                    name="originalPrice"
                                                    onChange={(e) => this.onChange(e)}
                                                    suffix="đ"
                                                />
                                            </HMS.FormWrapperInputComponent> */}
                                            {
                                                (action === "CREATE") && (
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.group.createvoucher`)}
                                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                    >
                                                        <AntInput
                                                            disabled={!createVoucher || voucherRun || voucherInvalid || data.productIds.length === 1 && (data.productIds[0] === (DEFINE.GENERAL.PRODUCT_TYPE.VINPEARL_LAND))}
                                                            value={data.createVoucherNumber ? Func.formatMoney(data.createVoucherNumber.toString()) : ""}
                                                            name="createVoucherNumber"
                                                            onChange={(e) => this.onChange(e)}
                                                            suffix={
                                                                <Checkbox
                                                                    name={`createVoucher`}
                                                                    checked={createVoucher}
                                                                    disabled={data.productIds.length === 1 && (data.productIds[0] === (DEFINE.GENERAL.PRODUCT_TYPE.VINPEARL_LAND))}
                                                                    onChange={this.onCreateVoucher} />
                                                            }
                                                        />
                                                    </HMS.FormWrapperInputComponent>
                                                )
                                            }
                                        </div>
                                        <div className={`col-md-6`}>
                                            {/* <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.salePrice}
                                                validation={validation.salePrice}
                                                labelTitle={t(`item.group.salePrice`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input
                                                    disabled={voucherRun || voucherInvalid}
                                                    value={data.salePrice ? Func.formatMoney(data.salePrice.toString()) : ""}
                                                    onChange={this.onChange}
                                                    name="salePrice"
                                                    suffix="đ"
                                                />
                                            </HMS.FormWrapperInputComponent> */}
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.limitNumberOfSalesPerUser}
                                                validation={validation.limitNumberOfSalesPerUser}
                                                labelTitle={t(`item.group.limitNumberOfSalesPerUser`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input type="text"
                                                    disabled={voucherInvalid}
                                                    autoComplete="off"
                                                    className="form-control" name="limitNumberOfSalesPerUser"
                                                    onChange={this.onChange}
                                                    value={data.limitNumberOfSalesPerUser ? Func.formatMoney(data.limitNumberOfSalesPerUser.toString()) : ""} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-12`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.shortDescription}
                                                validation={validation.shortDescription}
                                                labelTitle={t(`item.group.shortDescription`)}
                                            >
                                                <TextArea
                                                    className="form-control" name="shortDescription" onChange={this.onChange}
                                                    value={Func.checkUndefine(data.shortDescription)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.order}
                                                validation={validation.order}
                                                labelTitle={t(`item.group.order`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    placeholder=''
                                                    className="form-control"
                                                    name="order"
                                                    onChange={this.onChange}
                                                    value={data.order} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.name}
                                                // validation={validation.name}
                                                labelTitle={t(`item.group.tag`)}
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    // placeholder={Func.formatValidation(t('validation.statusCode.code.10'), t(`item.group.name`))}
                                                    className="form-control" name="tag" onChange={this.onChange}
                                                    value={data.tag ? data.tag : ""} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-md-6`} style={{ position: 'relative' }}>
                                    <HMS.HeaderComponent title={t('item.group.showInfo.available')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div className="row align-items-center mb-3">
                                        <div className={`col-md-3`}>
                                            <HMS.CheckboxComponent
                                                name='isAvailable'
                                                disabled={voucherInvalid}
                                                className={`mr-4`}
                                                onChange={this.onChange}
                                                checked={data.isAvailable}>{t(`item.group.isAvailable`)}
                                            </HMS.CheckboxComponent>
                                        </div>

                                        <div className={`col-md-3`}>
                                            <HMS.CheckboxComponent
                                                name='isSpecial'
                                                disabled={voucherInvalid}
                                                className={`mr-4`}
                                                onChange={this.onChange}
                                                checked={data.isSpecial}>{t(`item.group.isSpecial`)}
                                            </HMS.CheckboxComponent>
                                        </div>

                                        <div className={`col-md-6`}>
                                            <HMS.CheckboxComponent
                                                name='isSaleToWeb'
                                                disabled={voucherInvalid}
                                                className={`mr-4`}
                                                onChange={this.onChange}
                                                checked={data.isSaleToWeb}>{t(`item.group.isSaleToWeb`)}
                                            </HMS.CheckboxComponent>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.startDate}
                                                validation={validation.startDate}
                                                labelTitle={t(`item.group.startDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            format={DATE_TIME_FORMAT.SHORT_DATE}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            value={!isGetItem ? data.startDate || null : moment(new Date())}
                                                            name={'startDate'}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.endDate}
                                                validation={validation.endDate}
                                                labelTitle={t(`item.group.endDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            name={'endDate'}
                                                            format={DATE_TIME_FORMAT.SHORT_DATE}
                                                            value={!isGetItem ? data.endDate || null : moment(new Date())}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.saleStartDate}
                                                validation={validation.saleStartDate}
                                                labelTitle={t(`item.group.saleStartDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            showTime
                                                            name={'saleStartDate'}
                                                            format={DATE_TIME_FORMAT.DATE_TIME}
                                                            value={!isGetItem ? data.saleStartDate || null : moment(new Date())}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.saleEndDate}
                                                validation={validation.saleEndDate}
                                                labelTitle={t(`item.group.saleEndDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                    <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            showTime
                                                            name={'saleEndDate'}
                                                            format={DATE_TIME_FORMAT.DATE_TIME}
                                                            value={!isGetItem ? data.saleEndDate || null : moment(new Date())}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.numberOfBookingPeriod}
                                                validation={validation.numberOfBookingPeriod}
                                                labelTitle={`${t(`item.group.numberOfBookingPeriod`)} ( số ngày )`}
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    className="form-control"
                                                    name="numberOfBookingPeriod"
                                                    onChange={(e) => this.onChange(Number(e.target.value), 'numberOfBookingPeriod')}
                                                    value={data.numberOfBookingPeriod ? data.numberOfBookingPeriod : ''} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.bookingPeriod}
                                                validation={validation.bookingPeriod}
                                                labelTitle={t(`item.group.bookingPeriod`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            name={'bookingPeriod'}
                                                            format={DATE_TIME_FORMAT.SHORT_DATE}
                                                            value={!isGetItem ? data.bookingPeriod || null : moment(new Date())}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.stayStartDate}
                                                // validation={validation.stayStartDate}
                                                labelTitle={t(`item.group.stayStartDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            format={DATE_TIME_FORMAT.SHORT_DATE}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            value={!isGetItem ? data.stayStartDate || null : moment(new Date())}
                                                            name={'stayStartDate'}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.stayEndDate}
                                                // validation={validation.stayEndDate}
                                                labelTitle={t(`item.group.stayEndDate`)}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <HMS.DatePickerComponent
                                                            disabled={voucherInvalid}
                                                            disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                            onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                            name={'stayEndDate'}
                                                            format={DATE_TIME_FORMAT.SHORT_DATE}
                                                            value={!isGetItem ? data.stayEndDate || null : moment(new Date())}
                                                            placeholder=""
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <HMS.HeaderComponent title={t('item.group.showInfo.condition')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.voucherType}
                                                validation={validation.voucherType}
                                                labelTitle={t(`item.group.voucherType`)}
                                            >
                                                <Select className={`form-control`}
                                                    disabled={voucherRun || voucherInvalid}
                                                    name={`voucherType`}
                                                    value={Func.checkUndefine(data.voucherType)}
                                                    onChange={this.onChange}>
                                                    <Option
                                                        value="">{Func.formatValidation(t('validation.statusCode.code.10'), t(`item.group.voucherType`))}</Option>
                                                    <Option value={DEFINE.GENERAL.VOUCHER_TYPE.PERCENT}>Giảm theo
                                                        %
                                                    </Option>
                                                    <Option value={DEFINE.GENERAL.VOUCHER_TYPE.MONEY}>Giảm theo
                                                        Tiền
                                                    </Option>
                                                    <Option value={DEFINE.GENERAL.VOUCHER_TYPE.GIFT}>Miễn phí sử
                                                        dụng
                                                    </Option>
                                                </Select>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={data.voucherType !== DEFINE.GENERAL.VOUCHER_TYPE.GIFT}
                                                isValidation={true}
                                                dataValidation={data.discountValue}
                                                validation={validation.discountValue}
                                                labelTitle={t(`item.group.discountValue`)}
                                            >
                                                <Input
                                                    disabled={data.voucherType === 'gift' || data.voucherType === "" || !data.voucherType || voucherRun || voucherInvalid}
                                                    value={data.discountValue ? Func.formatMoney(data.discountValue.toString()) : ""}
                                                    name="discountValue"
                                                    onChange={this.onChange}
                                                    suffix={
                                                        data.voucherType === DEFINE.GENERAL.VOUCHER_TYPE.PERCENT ? `%` : "đ"
                                                    }
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.limitNumberOfTimes}
                                                validation={validation.limitNumberOfTimes}
                                                labelTitle={t(`item.group.limitNumberOfTimes`)}
                                            >
                                                <Input type="text"
                                                    disabled={voucherRun || voucherInvalid}
                                                    autoComplete="off"
                                                    placeholder={0}
                                                    className="form-control"
                                                    name="limitNumberOfTimes"
                                                    onChange={this.onChange}
                                                    value={data.limitNumberOfTimes ? Func.formatMoney(data.limitNumberOfTimes.toString()) : ""} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isValidation={true}
                                                dataValidation={data.maxDiscountValue}
                                                validation={validation.maxDiscountValue}
                                                labelTitle={t(`item.group.maxDiscountValue`)}
                                            >
                                                <Input
                                                    disabled={(data.voucherType !== DEFINE.GENERAL.VOUCHER_TYPE.PERCENT) || voucherRun || voucherInvalid}
                                                    value={data.maxDiscountValue ? Func.formatMoney(data.maxDiscountValue.toString()) : ""}
                                                    name="maxDiscountValue"
                                                    onChange={this.onChange}
                                                    suffix="đ"
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isValidation={true}
                                                dataValidation={data.minOrderValue}
                                                validation={validation.minOrderValue}
                                                labelTitle={t(`item.group.minOrderValue`)}
                                            >
                                                <Input
                                                    disabled={data.voucherType === DEFINE.GENERAL.VOUCHER_TYPE.GIFT || voucherInvalid || voucherRun}
                                                    value={data.minOrderValue ? Func.formatMoney(data.minOrderValue.toString()) : ""}
                                                    name="minOrderValue"
                                                    onChange={this.onChange}
                                                    suffix="đ"
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isValidation={true}
                                                dataValidation={data.maxOrderValue}
                                                validation={validation.maxOrderValue}
                                                labelTitle={t(`item.group.maxOrderValue`)}
                                            >
                                                <Input
                                                    disabled={data.voucherType === DEFINE.GENERAL.VOUCHER_TYPE.GIFT || voucherInvalid || voucherRun}
                                                    value={data.maxOrderValue ? Func.formatMoney(data.maxOrderValue.toString()) : ""}
                                                    name="maxOrderValue"
                                                    onChange={this.onChange}
                                                    suffix="đ"
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    {action === DETAIL_ACTIONS.TRANSLATE &&
                                        <div className="bg-white form-input-visible-hide-backdrop"></div>
                                    }
                                </div>
                            </HMS.FormWrapperItem>
                            {this.renderGroupPrices()}
                            <HMS.FormWrapperItem>
                                <div className='col-md-12' style={{ overflow: 'hidden' }}>
                                    <HMS.HeaderComponent title={t('item.group.showInfo.installment')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden' }}>
                                        <div className="col-md-3 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={isInstallment ? true : false}
                                                isValidation={true}
                                                dataValidation={data.installmentFee}
                                                validation={validation.installmentFee}
                                                labelTitle={t(`item.group.installmentFee`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Wrapper style={{ display: 'flex' }}>
                                                    <Select className={`form-control`}
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentFee")).toLowerCase())}
                                                        value={data.installmentFee}
                                                        onChange={(e) => this.onChange(e.target.value, 'installmentFee')}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <Option key={0} value=''>{t(`item.group.installmentFee_enum.UN_KNOW`)}</Option>
                                                        {INSTALLMENT_ENUM.INSTALLMENT_FREE.map((value, index) => {
                                                            return <Option key={index + 1} value={value}>{t(`item.group.installmentFee_enum.${value}`)}</Option>
                                                        })}
                                                    </Select>
                                                </Wrapper>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-3 p-0 pl-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={isInstallment ? true : false}
                                                isValidation={true}
                                                dataValidation={data.installmentLimit}
                                                validation={validation.installmentLimit}
                                                labelTitle={t(`item.group.installmentLimit`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Wrapper style={{ display: 'flex' }}>
                                                    <Select className={`form-control`}
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentLimit")).toLowerCase())}
                                                        value={data.installmentLimit}
                                                        onChange={(e) => this.onChange(e.target.value, 'installmentLimit')}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <Option key={0} value=''>{t(`item.group.installmentLimit_enum.UN_KNOW`)}</Option>
                                                        {Object.keys(INSTALLMENT_ENUM.INSTALLMENT_LIMIT).map((value, index) => {
                                                            return <Option key={index + 1} value={INSTALLMENT_ENUM.INSTALLMENT_LIMIT[value]}>{t(`item.group.installmentLimit_enum.${value}`)}</Option>
                                                        })}
                                                    </Select>
                                                </Wrapper>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className="col-md-12">
                                    <HMS.HeaderComponent title={t('item.group.showInfo.introduce')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden' }}>
                                        <div className="col-md-6 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.description}
                                                validation={validation.description}
                                                labelTitle={t(`item.group.description`)}
                                            >
                                                <RichTextEditor
                                                    editor={ClassicEditor}
                                                    disabled={voucherInvalid}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.GROUP_THUMB }}
                                                    data={this.state.data.description || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "description")
                                                    }}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6 p-0 pl-2">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.group.highlight`)}
                                            >
                                                <RichTextEditor
                                                    editor={ClassicEditor}
                                                    disabled={voucherInvalid}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.GROUP_THUMB }}
                                                    data={this.state.data.highlight || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "highlight")
                                                    }}
                                                />


                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.group.conditionOfUse`)}
                                            >
                                                <RichTextEditor
                                                    disabled={voucherInvalid}
                                                    editor={ClassicEditor}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.GROUP_THUMB }}
                                                    data={this.state.data.conditionOfUse || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "conditionOfUse")
                                                    }}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6 p-0 pl-2">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.group.operationManuals`)}
                                            >
                                                <RichTextEditor
                                                    disabled={voucherInvalid}
                                                    editor={ClassicEditor}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.GROUP_THUMB }}
                                                    data={this.state.data.operationManuals || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "operationManuals")
                                                    }}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.thumbImage}
                                        validation={validation.thumbImage}
                                        labelTitle={t(`item.tour.thumbImage`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={isUpload}
                                            disabledUpload={voucherInvalid}
                                            disabledRemove={voucherInvalid}
                                            thumbnailSize="100%"
                                            buttonSize={120}
                                            thumbnailStyle={{ maxHeight: 250 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            onRemoveThumbnail={this.removeThumbImage}
                                            thumbnails={this.state.thumbImage ? this.getThumbSources([this.state.thumbImage]) : undefined} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.images}
                                        validation={validation.images}
                                        labelTitle={t(`item.group.images`)}
                                    >
                                        <UploadImage
                                            multiple={true}
                                            loading={isUploadMultiple}
                                            thumbnailSize={120}
                                            buttonSize={120}
                                            disabledUpload={this.showImageMultiple().length > 6 || voucherInvalid}
                                            disabledRemove={voucherInvalid}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFileMultiple}
                                            onRemoveThumbnail={(src, index) => this.removeImage(this.getImageThumbBySrc(src))}
                                            thumbnails={this.getThumbSources(this.state.fileMultiple)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    renderGroupPrices() {
        const { t } = this.props;
        const { data, validation, action, checkData, } = this.state;
        let voucherRun = checkData ? ((new Date(checkData.saleStartDate)).getTime() < (new Date()).getTime()) : false;
        let voucherInvalid = checkData ? ((new Date(checkData.endDate)).getTime() < (new Date()).getTime()) : false;
        if (action !== DETAIL_ACTIONS.UPDATE || (permissionActions && permissionActions.allowUpdatePrice)) {
            voucherRun = false;
            voucherInvalid = false
        }
        return (
            <HMS.FormWrapperItem>
                <div className={`col-md-12 row m-0 p-0 ${get(validation, 'groupPrices.messageError') ? 'border-red' : ''}`}
                    style={{ overflow: 'hidden' }}>
                    <HMS.HeaderComponent title={t('item.group.prices')}
                        subTitle={<Span className="colorRed">{validation.groupPrices ? validation.groupPrices.messageError : '*'}</Span>}
                        className="mb-3 p-2 ml-2 mr-2 col-md-12"
                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                    <div className="col-md-6 row m-0 p-0">
                        <h3 className="text-body col-md-12">{t(`item.group.priceLocales.VND`)}</h3>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.VND.originalPrice}
                                validation={get(validation, 'groupPrices.VND.originalPrice')}
                                labelTitle={t(`item.group.originalPrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.VND.originalPrice ? Func.formatMoney(data.groupPrices.VND.originalPrice.toString()) : ""}
                                    name="originalPriceVND"
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.VND.originalPrice = Number(Func.formatNumber(e.target.value));
                                        if (action === DETAIL_ACTIONS.CREATE) groupPrices.VND.isDefault = true
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.VND.salePrice}
                                validation={get(validation, 'groupPrices.VND.salePrice')}
                                labelTitle={t(`item.group.salePrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.VND.salePrice ? Func.formatMoney(data.groupPrices.VND.salePrice.toString()) : ""}
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.VND.salePrice = Number(Func.formatNumber(e.target.value));
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    name="salePriceVND"
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                    </div>
                    <div className="col-md-6 row m-0 p-0">
                        <h3 className="text-body col-md-12">{t(`item.group.priceLocales.USD`)}</h3>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.USD.originalPrice}
                                validation={get(validation, 'groupPrices.USD.originalPrice')}
                                labelTitle={t(`item.group.originalPrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.USD.originalPrice ? Func.formatMoney(data.groupPrices.USD.originalPrice.toString()) : ""}
                                    name="originalPriceUSD"
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.USD.originalPrice = Number(Func.formatNumber(e.target.value));
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.USD.salePrice}
                                validation={get(validation, 'groupPrices.USD.salePrice')}
                                labelTitle={t(`item.group.salePrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.USD.salePrice ? Func.formatMoney(data.groupPrices.USD.salePrice.toString()) : ""}
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.USD.salePrice = Number(Func.formatNumber(e.target.value));
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    name="salePriceUSD"
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                    </div>
                    <div className="col-md-6 row m-0 p-0">
                        <h3 className="text-body col-md-12">{t(`item.group.priceLocales.KRW`)}</h3>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.KRW.originalPrice}
                                validation={get(validation, 'groupPrices.KRW.originalPrice')}
                                labelTitle={t(`item.group.originalPrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.KRW.originalPrice ? Func.formatMoney(data.groupPrices.KRW.originalPrice.toString()) : ""}
                                    name="originalPriceKRW"
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.KRW.originalPrice = Number(Func.formatNumber(e.target.value));
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isValidation={true}
                                dataValidation={data.groupPrices.KRW.salePrice}
                                validation={get(validation, 'groupPrices.KRW.salePrice')}
                                labelTitle={t(`item.group.salePrice`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={voucherInvalid || voucherRun}
                                    value={data.groupPrices.KRW.salePrice ? Func.formatMoney(data.groupPrices.KRW.salePrice.toString()) : ""}
                                    onChange={(e) => {
                                        const groupPrices = data.groupPrices;
                                        groupPrices.KRW.salePrice = Number(Func.formatNumber(e.target.value));
                                        this.onChange(groupPrices, 'groupPrices')
                                    }}
                                    name="salePriceKRW"
                                    suffix="đ"
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                    </div>
                </div>
            </HMS.FormWrapperItem>
        )
    }

    showImageMultiple() {
        let voucherInvalid = this.state.checkData ? ((new Date(this.state.checkData.endDate)).getTime() < (new Date()).getTime()) : false;
        let data = this.state.fileMultiple;
        let arrayImg = [];
        if (data.length > 0) {
            data.map((i, k) => {
                arrayImg.push(
                    <div className={`col-md-2`} style={{ position: 'relative' }} key={k}>
                        {
                            !voucherInvalid && <Icon type={'close'} className={`cursorPointer removeImage`}
                                onClick={() => this.removeImage(i, k)} />
                        }
                        <img key={k}
                            src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${i.fileUri ? i.fileUri : i.fileUrl}`}
                            width={`100%`}
                            className={`cursorPointer img-thumbnail ml-3`} />
                    </div>
                )
            })
        }
        return arrayImg;
    }

    removeImage = (i, k) => {
        if (!i) return;
        const data = this.state.data;
        let oldArrayImages = this.state.fileMultiple;
        const images = (data.images ? data.images : []).filter(item => item !== i.fileName);
        let newOldArrayImages = [];
        if (oldArrayImages.length > 0) {
            oldArrayImages.filter(i2 => i2.fileName !== i.fileName && newOldArrayImages.push(i2));
        }
        data.images = images;
        this.setState({ fileMultiple: newOldArrayImages, data });
    };

    showThumbImage() {
        let voucherInvalid = this.state.checkData ? ((new Date(this.state.checkData.endDate)).getTime() < (new Date()).getTime()) : false;
        let data = this.state.thumbImage;
        if (this.state.thumbImage && Object.keys(this.state.thumbImage).length > 0) {
            return (
                <div className={`col-md-2`} style={{ position: 'relative' }}>
                    {
                        !voucherInvalid && <Icon type={'close'} className={`cursorPointer removeImage`}
                            onClick={() => this.removeThumbImage()} />
                    }
                    <img
                        src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${data.fileUri ? data.fileUri : data.fileUrl}`}
                        width={`100%`}
                        className={`cursorPointer img-thumbnail ml-3`} />
                </div>
            )
        }
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.fileUri ? t.fileUri : t.fileUrl}`)
    }

    getImageThumbBySrc(src) {
        const founds = (this.state.fileMultiple || []).filter(item => (src || '').endsWith(item.fileUri ? item.fileUri : item.fileUrl))
        return founds && founds.length && founds[0]
    }

    removeThumbImage = () => {
        this.setState({
            data: merge(this.state.data, {
                thumbImage: ""
            }),
            thumbImage: {},
        })
    }
}

const mapStateToProps = state => {
    return {
        file: state.uploadReducer,
        properties: state.propertyReducer,
        products: state.productReducer,
        groups: state.groupReducer,
        groupCategories: state.groupCategoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        onListAllProperties: (filters) => {
            dispatch(action.dataAllPropertyAction(filters))
        },
        onListAllProducts: (filters) => {
            dispatch(action.dataAllProductAction(filters))
        },
        getAllGroupCategories: (filters) => {
            dispatch(groupCategoryAction.getAllGroupCategories(filters))
        },
        onCreateGroup: (params) => {
            dispatch(action.createGroupAction(params))
        },
        onUpdateGroup: (id) => {
            dispatch(action.updateGroupAction(id))
        },
        onGetUpdate: (id) => {
            dispatch(action.getUpdateGroupAction(id))
        },
        createGroupTranslate: (group, language) => dispatch(groupActions.createGroupTranslate(group, language)),
        updateGroupTranslate: (group, language) => dispatch(groupActions.updateGroupTranslate(group, language)),
        deleteGroupTranslate: (group, refreshParams) => dispatch(groupActions.deleteGroupTranslate(group, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
